export default __webpack_public_path__ + "6e451b674f537dc7dd8d1a257ba3fa65.gif";